import React from "react";

import { useTranslation } from "react-i18next";

import {
	PromotionPhase,
	Standing,
} from "@data-types/sport-stats/SportStatsTypes";
import { TeamStandingRules } from "@features/offer/shared/statistics/components/team-standings";
import { observer } from "mobx-react";

import { TeamStandingsHeader } from "./TeamStandingsHeader";
import { TeamStandingsItem } from "./TeamStandingsItem";

import TeamStandingsStatsStore from "@state/stores/offer/statistics/TeamStandingsStatsStore";

export const TeamStandingsBody = observer(
	({
		standings,
		teamStandingsPromotions,
		groupName,
		store
	}: {
		standings: Standing[] | undefined;
		teamStandingsPromotions: { name: string; phase: PromotionPhase }[];
		groupName?: string;
		store: TeamStandingsStatsStore
	}) => {
		const { t } = useTranslation();

		return (
			<>
				<div className="card card--sectioned card--raised card--stats">
					<div className="card__header card--sectioned__header card--stats__header u-pad--bottom--2">
						<div className="card__title card__title--base card--stats__heading">
							{groupName ? (
								<>{groupName}</>
							) : (
								<>
									{t("EVENT.STATISTICS.TEAM_STANDINGS.TITLE")}
								</>
							)}
						</div>
					</div>

					<div className="card--sectioned__body card--stats__body">
						<div className="table--responsive u-pad--reset">
							<table className="table table--borderless table--stand">
								<TeamStandingsHeader
										teamStandingsFilter={
											store.teamStandingsFilter
											? store.teamStandingsFilter
											: undefined
										}
								/>

								<tbody className="table__body table__body--borderless">
									{standings?.map((standing, index) => (
										<TeamStandingsItem
											key={index}
											standing={standing}
											store={store}
                                            homeScore={standing.liveScore?.homeScore}
                                            awayScore={standing.liveScore?.awayScore}
                                            isAwayTeam={standing.liveScore?.isAwayTeam}
										/>
									))}
								</tbody>
							</table>
						</div>
					</div>

					{groupName && (
						<div className="card--stats__footer u-pad--top--2">
							<TeamStandingRules
								promotions={teamStandingsPromotions}
							/>
						</div>
					)}
				</div>

				{!groupName && (
					<TeamStandingRules promotions={teamStandingsPromotions} />
				)}
			</>
		);
	}
);
